import {Toast} from "vant"; 
import axios from 'axios'
import router from '../router'
import store from '@/store/index';
// axios配置
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = 'http://www.androidjdk.cn:8000/api/v1';
// axios.defaults.baseURL = 'http://mall.fuzhaokeji.com:8000/api/v1';
axios.defaults.baseURL = 'https://wd.wintexiot.cn/api/v1';
// axios.defaults.baseURL = 'http://localhost:8000/api/v1/';
axios.defaults.responseType = 'json';
axios.defaults.withCredentials = false;
let loadingInstance = null;

axios.interceptors.request.use((res) => {
  res.headers['x-token'] = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : ''
  res.headers['x-device'] = localStorage.getItem('deviceNum') ? localStorage.getItem('deviceNum') : ''
  res.headers['x-type'] = localStorage.getItem('loginType') ? localStorage.getItem('loginType') : ''
  store.commit('changePromising', 'add');
  return res;
}, function (error) {
  Toast("服务器异常");
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use((res) => {
  store.commit('changePromising','del');
  // console.log('返回值', res);
  if (loadingInstance) loadingInstance.close();
  return res.data;
}, function (error) {
  Toast("服务器异常");
  store.commit('changePromising', 'del');
  if (loadingInstance) loadingInstance.close();
  return Promise.reject(error);
});

export default axios;
